export interface ISiteRecipeHelper {
    getIngredients(): HTMLCollectionOf<HTMLElement>;
    getRecipeId(): string;
    getRecipeName(): string;
    getImage(): string;
    getUrl(): string;
}

export class DefaultSiteRecipeHelper implements ISiteRecipeHelper {
    getMetaContent(property: string): string {
        const meta = document.querySelectorAll(`meta[property="${property}"]`);
        if (meta.length && meta[0].hasAttribute('content')) {
            const attr = meta[0].getAttribute('content');
            if (attr && attr.length) {
                return attr;
            }
        }
        return '';
    }

    getIngredients(): HTMLCollectionOf<HTMLElement> {
        return document.getElementsByClassName('ingredients-item') as HTMLCollectionOf<HTMLElement>;
    }

    getRecipeId(): string {
        const attr = document.body.getAttribute('data-content-graph-id');
        if (!attr) return '';
        const split = attr.split('_');
        return split[split.length - 1];
    }

    getRecipeName(): string {
        const name = this.getMetaContent('og:title');
        if (name.length) return name;
        // No meta :( go with H1 tag
        const h1 = document.getElementsByTagName('h1');
        return (h1.length === 0) ? '' : h1[0].innerText;
    }

    getImage(): string {
        return this.getMetaContent('og:image');
    }

    getUrl(): string {
        return this.getMetaContent('og:url');
    }
}
